/**
 * Small helpers around the shared `queryString` slice value that
 * multiple validation-scoped components inspect to decide whether any
 * filter is currently applied.
 */

/** Sentinel value the query generator emits when no filter is active. */
export const ALL_QUERY_STRING = "(all)";

/**
 * `true` when `queryString` represents the "no filter applied" state:
 * undefined, empty, or the `(all)` sentinel.
 */
export function isNoFilterApplied(queryString: string | undefined): boolean {
  return (
    queryString === undefined ||
    queryString === "" ||
    queryString === ALL_QUERY_STRING
  );
}
